/// <amd-module name="VSSUI/Components/Spinner/Spinner" />
import * as React from "react";
import { announce } from "VSS/Core/Util/Accessibility";
import { css, getSafeId } from "VSSUI/Util";
import { ISpinnerProps, SpinnerOrientation, SpinnerSize } from "./Spinner.Props";

export const Spinner: React.FunctionComponent<ISpinnerProps> = props => {
    const { ariaLabel, ariaLive, className, id, label, orientation = SpinnerOrientation.column, size = SpinnerSize.medium } = props;

    // Only do this on mount; the aria-live region will handle any updates to props
    React.useEffect(() => {
        if (ariaLive === "assertive" || ariaLive === "polite") {
            announce(ariaLabel || label, ariaLive === "assertive");
        }
    }, []);

    return (
        <div
            aria-label={ariaLabel}
            aria-live={ariaLive}
            className={css(
                className,
                "bolt-spinner",
                orientation === SpinnerOrientation.column ? "flex-column text-center rhythm-vertical-8" : "flex-row flex-center rhythm-horizontal-8"
            )}
            id={getSafeId(id)}
        >
            <div className={css("bolt-spinner-circle", size)} />
            {label && <div className="bolt-spinner-label">{label}</div>}
        </div>
    );
};

// TODO: Remove if we fix Jest issue
Spinner.displayName = "Spinner";
